<!-- 这是顶部菜单tab栏的组件-->
<template>
  <div class="main">
    <div class="informationContent">
      <div class="box">
        <div class="contenMain">
          <!-- <div class="infConts">
            <div class="msText">联系我们 Contact us</div>
            <div class="msDetails">
              <div class="text">服务热线 Service Hotline:400-003-9133</div>
              <div class="text">企业邮箱 Company E-mail:service@macjhome.com</div>
              <div class="text">企业地址 Company Address:杭州市临平区南苑街道迎宾路IFC互联网+金融中心1幢6-7楼</div>
            </div>
          </div>
          <div class="ewmMain">
            <div class="imgMs">
              <img src="../../static/imgs/dy.png" class="img" />
              <div class="text">扫一扫，关注抖音</div>
            </div>
            <div class="imgMs">
              <img src="../../static/imgs/ewm.jpg" class="img" />
              <div class="text">扫一扫，关注公众号</div>
            </div>
          </div> -->
          <img src="../../static/imgs/lxwm3.jpg"  />
        </div>
      </div>
    </div>
    <div class="boxTow">
      <div class="msText">合伙人申请 Partner applications</div>
      <div class="profileList">
        <!-- <div class="profile">
          <div class="submitName">姓名:</div>
          <div class="submitData">
            <input placeholder="请输入" class="inp" v-model="list.name" type="text"
              onkeyup="this.value=this.value.replace(/[^\u4e00-\u9fa5]/g,'')" />
          </div>
        </div>
        <div class="profile">
          <div class="submitName">联系方式:</div>
          <div class="submitData">
            <input placeholder="请输入" class="inp" v-model="list.phone"
              onkeyup="this.value=this.value.replace(/\D/g,'')" />
          </div>
        </div>
        <div class="profile">
          <div class="submitName">业务类型:</div>
          <div>
            <div>
              <input v-model="list.type" readonly class="inp" placeholder="请选择" @click="handleShow" />
              <img src="../../static/imgs/bom.png" class="selectImg" />
            </div>
            <div class="optionList" v-if="show">
              <div class="optionName" v-for="(item, index) in options" @click="handleText(item)">{{ item.label }}</div>
            </div>
          </div>

        </div>
        <div class="profile">
          <div class="submitName">业务区域:</div>
          <div class="submitData">
            <div id="app">
              <el-cascader size="large" v-model="list.location" :options="listState" @change="handleChange" />
            </div>
          </div>
        </div> -->

        <el-form class="from">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <el-form-item>
                <div class="profile">
                  <div class="submitName">姓名 Name</div>
                  <div class="submitData">
                    <input placeholder="请输入" class="inp" v-model="list.name"/>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div class="profile">
                  <div class="submitName">联系方式 Contact:</div>
                  <div class="submitData">
                    <input placeholder="请输入" class="inp" v-model="list.phone"
                      onkeyup="this.value=this.value.replace(/\D/g,'')" />
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <el-form-item>
                <div class="profile">
                  <div class="submitName">业务类型 Service Type:</div>
                  <div>
                    <div>
                      <input v-model="value" readonly class="inp" placeholder="请选择" @click="handleShow" />
                      <img src="../../static/imgs/bom.png" class="selectImg" />
                    </div>
                    <div class="optionList" v-if="show">
                      <div class="optionName" v-for="(item, index) in options" @click="handleText(item)">{{ item.label
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div>

                <el-form-item>
                  <div class="profile">
                    <div class="submitName">业务区域 Service Area:</div>
                    <div class="submitData">
                      <el-cascader size="large" v-model="values" :options="listState" @change="handleChange" />
                      <!-- <input placeholder="请输入" class="inp" v-model="list.location" /> -->
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="btn" @click="handleBtn">提交 Submit</div>
    <div class="textMs">我们将在1个工作日内与您取得联系，如需帮助请拨打400-003-9133
      <div style="line-height: 36px;">We will contact you within 1 working day, please call 400-003-9133 if you need help</div>
    </div>
    <div class="bottomtMs">Copyright © 2022 MACJ All Rights Reserved备案号:浙ICP备2020033389号-1</div>
  </div>
</template>
<script>

import { agentApply } from "@/utils/api";//调接口引入
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
// data 为文件名
import { data } from '../../assets/data.js'

export default {
  name: "BottomContent",
  data() {
    return {
      listState: provinceAndCityData,
      selectedOptions: [],
      value: '',
      values: '',
      show: false,
      list: {
        type: null,
        name: '',
        location: '',
        phone: '',
      },
      options: [{
        value: 1,
        label: '绿色能源'
      }, {
        value: 2,
        label: '绿色建筑'
      }],
      value: '',
      submitData: { id: 1, },//提交按钮点击时的数据 ps:下拉数据v-model绑定为数据里面的value值 因此v-model=submitData.id
      //下拉菜单 获取数据后 直接赋值就行
      option1: [
        { text: '1', value: 0 },
        { text: '2', value: 1 },
        { text: '3', value: 2 },
      ],
    }
  },
  methods: {
    handleChange(e) {
      this.list.location = CodeToText[e[0]] + ',' + CodeToText[e[1]]
    },
    handleText(e) {
      this.value = e.label
      this.list.type = e.value
      this.show = !this.show
    },
    handleShow() {
      if (this.show == false) {
        this.show = true
      } else {
        this.show = false
      }
      // this.show = !this.show
    },
    handleBtn() {
      if (this.list.type == '') {
        this.$toast({
          message: '请选择您的业务类型'
        });
        return
      } else if (this.list.name == '') {
        this.$toast({
          message: '请填写您的姓名'
        });
        return
      } else if (this.list.phone == '') {
        this.$toast({
          message: '请选择您的手机号'
        });
        return
      } else if (!(/^1[34578]\d{9}$/.test(this.list.phone))) {
        this.$toast({
          message: '请输入正确的手机号'
        });
        return
      } else if (this.list.location == '') {
        this.$toast({
          message: '请选择您的业务区域'
        });
        return
      } else {
        console.log(this.list)
        agentApply(this.list).then(res => {
          const { data, code, msg } = res
          console.log('data', data)
          if (code == 0) {
            this.$toast({
              message: '您的信息已提交'
            });
            this.list = {}
            this.values = ''
            this.value = ''
          } else {
            this.$toast.fail(msg);
          }
        })
      }
    }
  },
  components: {},
  created() {
    
  },
  mounted() {
    layui.use('form', function () {
      let form = layui.form;
      form.render();   //更新所有form表单
      // form.render('select','aihao');
      //form.render('组件名','lay-filter名')
    });
  }
};
</script>

<style scoped>
/deep/.el-cascader-panel {
  zoom: 1.3;
}

.from {
  width: 1920px;
}

/deep/.el-cascader .el-input .el-input__inner {
  text-overflow: ellipsis;
  height: 56px;
  width: 260px;
  border: none;
  font-size: 28px;
  border-radius: 2px;
  margin-left: 2px;
  padding: 0 12px;
}

.optionName {
  font-size: 28px;
  height: 76px;
  line-height: 76px;
  color: #000;
  font-weight: bold;
  padding-left: 28px;
}

.optionName:hover {
  background-color: #BCBEC7;
}

.optionList {
  border: 3px solid #BCBEC7;
  border-radius: 5px;
  margin-left: 8px;
  margin-top: -48px;
  width: 188px;
  position: absolute;
  background-color: #fff;
  margin-top: 8px;
}

.inptext {
  font-size: 28px;
  color: #BCBEC7;
  margin-left: 36px;
  position: absolute;
  font-weight: bold;
  margin-top: 12px;
  padding: 8px 0;
}

.ewmMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 600px;
}

/** 原生下拉框更改增加下三角 原生很丑 */
.selectImg {
  width: 24px;
  height: 24px;
  position: relative;
  margin-left: -32px;
}

.main {
  /* position: absolute;
  bottom: 0; */
}

.bottomtMs {
  text-align: center;
  height: 88px;
  background: #333333;
  line-height: 88px;
  color: #fff;
  font-size: 24px;
}

.btn {
  padding: 0px 48px;
  background: #1f4fa9;
  border-radius: 5px 5px 5px 5px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  margin: 0 auto;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin-top: 36px;
}

.profileList {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  margin-top: 32px;
}

input::-webkit-input-placeholder {
  color: #BCBEC7;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #BCBEC7;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #BCBEC7;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #BCBEC7;

}

.inp {
  border: none;
  width: 188px;
  height: 56px;
  line-height: 56px;
  font-size: 28px;
  border-radius: 8px;
  color: #3c3232;
  margin-left: 8px;
  padding: 0 12px;
}

/* .select {
  border: none;
  width: 164px;
  height: 56px;
  font-size: 28px;
  border-radius: 8px;
  color: #3c3232;
  margin-left: 8px;
  padding: 0 12px;
  background: #fff;
} */

select {
  /*Chrome和Firefox里面的边框是不一样的，所以复写了一下*/
  border: solid 1px #000;

  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: #fff;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  padding-right: 14px;
}


/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand {
  display: none;
  background: #fff;

}

.profile {
  display: flex;
  align-items: center;
  justify-content: start;
}

/deep/.layui-input-block {
  height: 146px;
  margin-left: 0px;
}

/deep/.layui-form {
  height: 146px;
  width: 312px;
}

.submitName {
  color: #3D3D3D;
  font-size: 24px;

}

.contenMain img{
  width: 100%;
  height: 100%;
}

.imgMs {
  width: 268px;
  height: 268px;
  text-align: center;
}

.img {
  width: 268px;
}

.text {
  color: #979595;
  font-size: 24px;
  line-height: 36px;

}

.textMs {
  color: #979595;
  font-size: 24px;
  line-height: 120px;
  text-align: center;
}

.msDetails {
  margin-top: 24px;
}

.msText {
  font-size: 40px;
  color: #333333;
  font-weight: bold;
}

page {
  background-color: #fff;
}

.main {
  background-color: #F5F5F5;

}

.informationContent {
  border-bottom: 2px solid #D8D8D8;
  padding-bottom: 72px
}

.box {
  padding: 96px 120px 0 120px;
}

.boxTow {
  padding: 48px 120px 0 120px;
}
</style>
